import { render, staticRenderFns } from "./consultDetails.vue?vue&type=template&id=9276be6a&scoped=true"
import script from "./consultDetails.vue?vue&type=script&lang=js"
export * from "./consultDetails.vue?vue&type=script&lang=js"
import style0 from "./consultDetails.vue?vue&type=style&index=0&id=9276be6a&prod&lang=scss"
import style1 from "./consultDetails.vue?vue&type=style&index=1&id=9276be6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9276be6a",
  null
  
)

export default component.exports